<div class="spacer"></div>
<nav>
    <div class="logo">
        <a routerLink="/">
            <img src="../../../assets/images/logo.svg" alt="logo">
        </a>
        <i class="bi" [ngClass]="!open ? 'bi-list' : 'bi-x-lg'" (click)="open = !open"></i>
    </div>
    <div class="links" [class.open]="open">
        <a (click)="open = false" routerLinkActive="active" routerLink="/" [routerLinkActiveOptions]="{exact: true}" class="nav-link">home</a>
        <a (click)="open = false" routerLinkActive="active" routerLink="/stagione" class="nav-link">stagione</a>
        <a href="https://teatrocolosseo.eventim-inhouse.de/" target="_blank" class="nav-link">biglietti</a>
        <a href="https://teatrocolosseo.eventim-inhouse.de/webshop/webticket/shop?coupon" target="_blank" class="nav-link">card</a>
        <a (click)="open = false" routerLinkActive="active" routerLink="/info" class="nav-link">info</a>
        <a *ngIf="carnetAttivo" (click)="open = false" routerLinkActive="active" routerLink="/carnet" class="nav-link">carnet</a>
        <a (click)="open = false" routerLinkActive="active" routerLink="/news" class="nav-link">news</a>
        <a (click)="open = false" routerLinkActive="active" routerLink="/contatti" class="nav-link">contatti</a>
        <a href="https://archivio.teatrocolosseo.it" target="_blank" class="nav-link">archivio</a>
    </div>
</nav>